import { render } from "./NewBenchMark.vue?vue&type=template&id=81751328&scoped=true"
import script from "./NewBenchMark.vue?vue&type=script&lang=js"
export * from "./NewBenchMark.vue?vue&type=script&lang=js"

import "./NewBenchMark.vue?vue&type=style&index=0&id=81751328&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81751328"]])

export default __exports__